import { Component, OnInit, Inject } from '@angular/core';
import { ConfirmSignOtpComponent } from '../confirm-sign-otp/confirm-sign-otp.component';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { DigitalCertificateService } from 'src/app/core/services/digital-certificate.service';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { Message } from 'src/app/core/class/message';
import { SignDocumentService } from 'src/app/core/services/sign-document.service';
import { CommonService } from 'src/app/core/services/common.service';

@Component({
  selector: 'app-list-phone-otp',
  templateUrl: './list-phone-otp.component.html'
})
export class ListPhoneOtpComponent implements OnInit {
  /**
   * check focus.
   */
  checkFocus = false;
  
  /**
   * Check process success
   */
  success = false;

  /**
   * phone selected by user
   */
  selectedPhone: string;

  /**
   * variable check form change
   */
  isFormChanging = false;

  /**
   * List phone register otp
   */
  numberPhones: any;

  constructor(
    private dialogRef: MatDialogRef<ListPhoneOtpComponent>,
    private dialog: MatDialog,
    private digitalCertificateService: DigitalCertificateService,
    private message: Message,
    private signDocumentService: SignDocumentService,
    public commonService: CommonService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  /**
   * Init component
   */
  ngOnInit() {
    this.getListPhoneOtp();
  }

  /**
   * Get list phone register OTP
   */
  getListPhoneOtp() {
    this.digitalCertificateService.getListPhoneOtp().subscribe(rs => {
      this.numberPhones = rs.data;
    });
  }

  /**
   * Open dialog confirm code for sign OTP
   */
  onClickConfirmButton() {
    this.signDocumentService.generateTransaction(this.data.documentId, this.selectedPhone, this.data.signImages).subscribe(rs => {
      this.openDialogConfirmSignOTP(rs.data);
    });
  }

  /**
   * Open dialog confirm code for sign OTP
   */
  openDialogConfirmSignOTP(transactionId: string) {
    const dialogRef = this.dialog.open(ConfirmSignOtpComponent, {
      width: '40%',
      data: {
        documentId: this.data.documentId,
        transaction: transactionId,
        selectedPhone: this.selectedPhone
      }
    });

    dialogRef.afterClosed().subscribe(() => {
      if (dialogRef.componentInstance.success) {
        this.dialogRef.close();
        this.success = true;
      }
    });
  }

  /**
   * Click button cancel
   */
  onClickCancelButton() {
    this.dialogRef.close();
    if (this.isFormChanging) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '30%',
        data: this.message.getMessage('messages.confirm_change_data')
      });

      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.dialogRef.close();
        }
        dialogRe.close();
      });
    } else {
      this.dialogRef.close();
    }
  }
}
